import React from 'react';

import { Avatar, Box, Stack, Typography } from '@lyearn/ui';
import { ContentEntity, UserType } from '@/types/schema';

function userCollectionItemDetails(user: UserType) {
  return {
    Icon: (
      <Avatar
        classes={{ border: 'border border-solid border-divider' }}
        name={user.name || 'Avatar'}
        size="large"
        src={user.profilePicture || ''}
      />
    ),
    title: user.name,
    description: user.uniqueId,
  };
}

export default function ListItemContent({ item }: { item: UserType | ContentEntity }) {
  const itemDetails = userCollectionItemDetails(item as UserType);

  if (!itemDetails) {
    return null;
  }

  const { Icon, title, description } = itemDetails;

  return (
    <Box className="flex flex-1 overflow-hidden text-ellipsis p-8 items-center">
      {Icon}
      <Stack className="overflow-hidden ms-12" direction="col">
        <Stack alignItems="center" className="space-s-4">
          <Typography className="truncate" color="text-text-primary" variant="body-short-02">
            {title}
          </Typography>
        </Stack>
        <Typography color="text-text-secondary" variant="body-short-03">
          {description}
        </Typography>
      </Stack>
    </Box>
  );
}
